exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".icon-container {\n  display: inline-flex;\n  flex-direction: row;\n  width: 53px;\n  align-items: center;\n  justify-content: center; }\n  .icon-container .material-icons {\n    cursor: pointer;\n    color: #4a4a4a; }\n  .icon-container.disabled-icon .material-icons {\n    color: #ddd; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/lib/loader.js!./src/components/ConfirmIcon.scss
// module id = 705
// module chunks = 0